<template>
  <transition name="fade">
    <div v-if="visible" class="agreement-overlay">
      <div class="agreement-card">
        <div class="agreement-card__header">
          <div class="agreement-card__title">Внимание</div>
        </div>
        <div class="agreement-card__subtitle">
          Чтобы продолжить использовать сервис, подтвердите согласие с документами ниже
        </div>

        <div class="agreement-card__checkboxes">
          <label class="agreement-checkbox">
            <input type="checkbox" v-model="first" />
            <span class="agreement-checkbox__label">Я даю согласие обработку, хранение и передачу персональных данных, в том числе третьим лицам</span>
          </label>
          <label class="agreement-checkbox">
            <input type="checkbox" v-model="second" />
            <span class="agreement-checkbox__label" v-html="documentsHtml"></span>
          </label>
          <label class="agreement-checkbox">
            <input type="checkbox" v-model="third" />
            <span class="agreement-checkbox__label">Я даю согласие на получение уведомлений и иной информации, в том числе рекламной об услугах и сервисах любым способом</span>
          </label>
        </div>

        <button
            type="button"
            class="agreement-card__confirm"
            :disabled="!canSubmit || loading"
            @click="emitConfirm"
        >
          <span v-if="!loading">Подтвердить</span>
          <span v-else>Сохраняем…</span>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
const LINK_PRIVACY = "https://itk-rus.ru/politika-obrabotki-i-ispolzovaniya-personalnyix-dannyix.html";
const LINK_SERVICES = "https://itk-rus.ru/assets/doc/2025/poryadok-okazaniya-uslug-svyazi-abonentam.pdf";
const LINK_CONTRACT = "https://itk-rus.ru/soglasie-na-obrabotku-personalnyix-dannyix.html";

export default {
  name: 'widget-agreement-modal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      first: false,
      second: false,
      third: false
    };
  },
  computed: {
    canSubmit() {
      return this.first && this.second && this.third;
    },
    documentsHtml() {
      return `Я ознакомился и согласен с <a href="${LINK_PRIVACY}" target="_blank" rel="noopener">Политикой о конфиденциальности и защите персональных данных</a>, ` +
        `<a href="${LINK_SERVICES}" target="_blank" rel="noopener">Правилами оказания услуг связи абонентам</a> и <a href="${LINK_CONTRACT}" target="_blank" rel="noopener">Договором</a>`;
    }
  },
  watch: {
    visible(value) {
      if (value) {
        this.resetState();
      }
    }
  },
  methods: {
    emitConfirm() {
      if (!this.canSubmit || this.loading) {
        return;
      }
      this.$emit('confirm');
    },
    resetState() {
      this.first = false;
      this.second = false;
      this.third = false;
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.agreement-overlay {
  position: fixed;
  inset: 0;
  background: rgba(16, 30, 52, 0.55);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 24px;
  z-index: 2000;
}

.agreement-card {
  width: min(520px, 100%);
  background: #ffffff;
  border-radius: 32px 32px 24px 24px;
  padding: 28px;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  gap: 20px;
}


.agreement-card__header {
  display: flex;
  align-items: center;
  justify-content: center;
}

.agreement-card__title {
  font-family: 'Mont', serif;
  font-size: 1.4rem;
  font-weight: 800;
  color: #24484e;
}

.agreement-card__subtitle {
  font-family: 'Mont', serif;
  font-size: 0.95rem;
  color: #4a5a64;
}

.agreement-card__checkboxes {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.agreement-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.agreement-checkbox input {
  margin-top: 2px;
  width: 20px;
  height: 20px;
  accent-color: #0082bf;
}

.agreement-checkbox__label {
  font-family: 'Mont', serif;
  font-size: 0.9rem;
  color: #3c4b54;
  line-height: 1.45;
}

.agreement-checkbox__label a {
  color: #0082bf;
  font-weight: 600;
  text-decoration: underline;
}

.agreement-card__confirm {
  margin-top: 8px;
  border: none;
  border-radius: 18px;
  padding: 14px;
  font-family: 'Mont', serif;
  font-weight: 700;
  font-size: 1rem;
  color: #ffffff;
  background: #0082bf;
  box-shadow: 0 16px 32px rgba(0, 130, 191, 0.22);
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.agreement-card__confirm:disabled {
  background: #a6b4c2;
  box-shadow: none;
  cursor: not-allowed;
}

.agreement-card__confirm:hover:enabled {
  transform: translateY(-1px);
  opacity: 0.95;
}

@media (max-width: 560px) {
  .agreement-overlay {
    align-items: flex-end;
  }

  .agreement-card {
    border-radius: 32px 32px 0 0;
    padding: 24px;
  }
}
</style>
